import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AlarmMsgModule } from '@blade-sxp/monitor/store/alarm-msg';
import { saveUserLastOperationRecord, getUserLastOperationRecord } from '@blade/common/api/alarm-center';
let titleHead = class titleHead extends Vue {
    mSwitch = true;
    get messageSwitch() {
        return AlarmMsgModule.messageSwitch;
    }
    onMessageSwitchChange(newVal) {
        this.mSwitch = AlarmMsgModule.messageSwitch;
    }
    mounted() {
        this.getUserLastOperationRecordFunc();
    }
    getUserLastOperationRecordFunc() {
        getUserLastOperationRecord(['alarmMsgSwitch'])
            .then((res) => {
            if (res) {
                Object.keys(res).map((item) => {
                    if (item === 'alarmMsgSwitch') {
                        AlarmMsgModule.getMessageSwitch(res[item]?.operationRecord?.alarmMsgSwitch);
                    }
                });
            }
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    onDarwClose() {
        this.$emit('darwClose');
    }
    changeMessageSwitch(val) {
        this.mSwitch = val;
        this.saveUserLastOperationRecordFunc(val);
        AlarmMsgModule.getMessageSwitch(val);
    }
    saveUserLastOperationRecordFunc(data) {
        let params = {
            operationRecords: [
                {
                    operationRecord: {
                        alarmMsgSwitch: data,
                    },
                    recordKey: 'alarmMsgSwitch',
                },
            ],
        };
        saveUserLastOperationRecord(params)
            .then((res) => {
            this.$message({
                message: `${this.$t('toolSuccess')}`,
                type: 'success',
            });
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
};
__decorate([
    Watch('messageSwitch', { immediate: true })
], titleHead.prototype, "onMessageSwitchChange", null);
titleHead = __decorate([
    Component({
        name: 'titleHead',
        components: {},
        i18n: {
            messages: {
                'en-us': {
                    systemList: 'Alert Notification',
                    toolSuccess: 'Successfully Modified',
                },
                zh: {
                    systemList: '告警消息推送',
                    toolSuccess: '修改成功',
                },
            },
        },
    })
], titleHead);
export default titleHead;
